/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VM }                                   from 'g3w-eventbus';
import GUI                                      from "services/gui";
import RelationsComponent                       from 'components/Relations.vue';
import RelationComponent                        from 'components/Relation.vue';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'relation-page',

  data() {
    const {
      relation =         null,
      relations =        [],
      nmRelation,
      feature =           null,
      currentview =      'relations',
      chartRelationIds = [],
      layer,
    } = this.$options;
    return {
      loading:         false,
      state:           null,
      error:           false,
      previousview:    currentview,
      feature,
      currentview,
      relation,
      relations,
      nmRelation,
      chartRelationIds,
      layer,
    }
  },
  components: {
    'relations': RelationsComponent,
    'relation':  RelationComponent
  },
  computed: {
    showrelationslist() {
      return 'relations' === this.previousview && this.relations.length > 1;
    }
  },
  methods: {

    reloadLayout() {
      VM.$emit('reload-relations');
    },
    async showRelation(relation) {
      this.loading        = true;
      this.relation       = relation;
      try {
        GUI.setCurrentContentOptions({
          title: relation.name,
          crumb: { title: relation.name, text: true }/**@since 3.11.0 text attribute */
        });
        await this.$nextTick();
        this.previousview = this.currentview;
        this.currentview  = 'relation';
      } catch(e) {
        console.warn(e);
      }

      this.loading = true;
    },
    setRelationsList() {
      this.previousview = 'relation';
      this.currentview  = 'relations';
      GUI.setCurrentContentOptions({ crumb: { title: 'info.list_of_relations' } });
      this.loading = false;
    },
  },
  beforeMount() {
    if ('relation' === this.currentview  || (1 === this.relations.length && 'ONE' === this.relations[0].type)) {
      this.showRelation(this.relations[0])
    }
  },
  async mounted() {
    /**
     * Order relations by name
     */
    this.relations.sort(({ name: relationName1 }, { name: relationName2 }) => {
      if (relationName1 < relationName2) return -1;
      if (relationName1 > relationName2) return 1;
      return 0;
    });
    await this.$nextTick();
    if (this.error) { requestAnimationFrame(() => GUI.popContent()) }
    this.error = false;
  },
  created() {
    this.$on('resize-component', this.reloadLayout);
  }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"query-relations-page"},[_c(_vm.currentview,{ref:_vm.currentview,tag:"component",attrs:{"loading":_vm.loading,"previousview":_vm.previousview,"relations":_vm.relations,"relation":_vm.relation,"feature":_vm.feature,"layer":_vm.layer,"chartRelationIds":_vm.chartRelationIds,"showrelationslist":_vm.showrelationslist}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RelationsPage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__